import useIsStuck from '../../hooks/useIsStuck';

// Sticky banner shell: full-bleed when stuck (below the 48px navbar),
// rounded card otherwise. accentClass colors the left border; floatingClass
// applies extra classes to the non-stuck (floating) variant.
function StickyBanner({ children, accentClass = '', floatingClass = '' }) {
  const [stuckRef, isStuck] = useIsStuck();
  return (
    <>
      <div ref={stuckRef} className="h-px w-full" aria-hidden="true" />
      <div
        className={`sticky top-[48px] z-20 border-l-4 border-[color:var(--app-border)] bg-[color:var(--app-surface)] py-3 pl-3 pr-4 shadow-sm sm:pl-5 sm:pr-6 ${
          isStuck
            ? 'mx-0 rounded-none border-x-0 border-t-0 border-b'
            : `mx-4 rounded-lg border sm:mx-6 ${floatingClass}`
        } ${accentClass}`}
      >
        {children}
      </div>
    </>
  );
}

export default StickyBanner;
